import React, { useState } from "react";
import "../../../assets/css/admin/Reports.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const Reports = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [selectedReport, setSelectedReport] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");

  const reportsData = [
    {
      id: "TKT-001",
      type: "user-dispute",
      title: "Payment Issue - Course Access",
      createdBy: "Ahmed Khan",
      createdByRole: "Student",
      against: "Dr. Ali Ahmad",
      againstRole: "Mentor",
      priority: "high",
      status: "submitted",
      description:
        "Student paid for premium course but access was not granted. Multiple emails sent with no response.",
      date: "2025-01-10",
      time: "09:30 AM",
      evidence: ["payment_receipt.pdf", "email_thread.pdf"],
      updates: 3,
    },
    {
      id: "TKT-002",
      type: "user-dispute",
      title: "Inappropriate Behavior in Chat",
      createdBy: "Sara Ali",
      createdByRole: "Student",
      against: "Hassan Raza",
      againstRole: "Student",
      priority: "high",
      status: "under-review",
      description:
        "User using offensive language and harassing other students in group chat discussions.",
      date: "2025-01-10",
      time: "11:45 AM",
      evidence: ["chat_screenshots.png"],
      updates: 5,
    },
    {
      id: "TKT-003",
      type: "user-dispute",
      title: "Quiz Grading Dispute",
      createdBy: "Fatima Malik",
      createdByRole: "Student",
      against: "Prof. Ayesha Tariq",
      againstRole: "Mentor",
      priority: "medium",
      status: "resolved",
      description:
        "Student believes quiz was graded incorrectly. Requesting manual review of answers.",
      date: "2025-01-09",
      time: "02:15 PM",
      evidence: ["quiz_answers.pdf"],
      updates: 7,
      resolution:
        "After review, grade was adjusted from 75% to 85%. Student notified.",
    },
    {
      id: "TKT-004",
      type: "technical-support",
      title: "Video Player Not Loading",
      createdBy: "Eng. Bilal Hassan",
      createdByRole: "Mentor",
      against: null,
      againstRole: null,
      priority: "high",
      status: "in-progress",
      description:
        "Course videos are not loading on the platform. Issue reported by multiple students. Browser console shows 403 errors.",
      date: "2025-01-09",
      time: "04:30 PM",
      evidence: ["error_screenshot.png", "console_log.txt"],
      updates: 2,
    },
    {
      id: "TKT-005",
      type: "technical-support",
      title: "Certificate Download Failing",
      createdBy: "Zainab Yusuf",
      createdByRole: "Student",
      against: null,
      againstRole: null,
      priority: "medium",
      status: "submitted",
      description:
        "Certificate PDF download button is unresponsive after course completion. Tried on multiple browsers.",
      date: "2025-01-08",
      time: "10:20 AM",
      evidence: ["course_feedback.pdf"],
      updates: 1,
    },
    {
      id: "TKT-006",
      type: "user-dispute",
      title: "Mentor Not Responding",
      createdBy: "Kamran Siddiqui",
      createdByRole: "Student",
      against: "Dr. Ali Ahmad",
      againstRole: "Mentor",
      priority: "low",
      status: "closed",
      description: "Mentor has not responded to queries for over 2 weeks.",
      date: "2025-01-07",
      time: "03:45 PM",
      evidence: [],
      updates: 4,
      resolution:
        "Mentor was on medical leave. Student informed and session rescheduled.",
    },
    {
      id: "TKT-007",
      type: "technical-support",
      title: "Login 2FA Code Not Received",
      createdBy: "Hassan Raza",
      createdByRole: "Student",
      against: null,
      againstRole: null,
      priority: "high",
      status: "in-progress",
      description:
        "Two-factor authentication code is not being received via email. Unable to log in to the platform.",
      date: "2025-01-06",
      time: "08:15 AM",
      evidence: ["email_log.pdf"],
      updates: 3,
    },
  ];

  const stats = {
    total: reportsData.length,
    submitted: reportsData.filter((r) => r.status === "submitted").length,
    inProgress: reportsData.filter(
      (r) => r.status === "under-review" || r.status === "in-progress",
    ).length,
    resolved: reportsData.filter(
      (r) => r.status === "resolved" || r.status === "closed",
    ).length,
    highPriority: reportsData.filter((r) => r.priority === "high").length,
  };

  const filteredReports = reportsData.filter((report) => {
    if (activeTab === "dispute" && report.type !== "user-dispute") return false;
    if (activeTab === "technical" && report.type !== "technical-support")
      return false;
    if (statusFilter !== "all" && report.status !== statusFilter) return false;
    return true;
  });

  const getPriorityColor = (priority) => {
    const colors = { high: "#d32f2f", medium: "#f57c00", low: "#388e3c" };
    return colors[priority] || "#999";
  };

  const getStatusConfig = (status) => {
    const map = {
      submitted: { label: "Submitted", cls: "status-submitted" },
      "under-review": { label: "Under Review", cls: "status-review" },
      "in-progress": { label: "In Progress", cls: "status-inprogress" },
      resolved: { label: "Resolved", cls: "status-resolved" },
      closed: { label: "Closed", cls: "status-closed" },
    };
    return map[status] || map.submitted;
  };

  const getTypeConfig = (type) => {
    if (type === "user-dispute")
      return { label: "User Dispute", cls: "type-dispute" };
    return { label: "Technical Support", cls: "type-technical" };
  };

  return (
    <AdminLayout>
      <div className="reports-container">
        {/* Header */}
        <div className="reports-header">
          <p className="reports-subtitle">
            Manage and resolve platform tickets
          </p>
        </div>

        {/* Stats Grid */}
        <div className="reports-stats-grid">
          <div className="stat-card">
            <div className="stat-icon total">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
            </div>
            <div className="stat-content">
              <span className="stat-value">{stats.total}</span>
              <span className="stat-label">Total Tickets</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon pending">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <div className="stat-content">
              <span className="stat-value">{stats.submitted}</span>
              <span className="stat-label">Submitted</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon review">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <div className="stat-content">
              <span className="stat-value">{stats.inProgress}</span>
              <span className="stat-label">In Progress</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon resolved">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <div className="stat-content">
              <span className="stat-value">{stats.resolved}</span>
              <span className="stat-label">Resolved / Closed</span>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon critical-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
            <div className="stat-content">
              <span className="stat-value">{stats.highPriority}</span>
              <span className="stat-label">High Priority</span>
            </div>
          </div>
        </div>

        {/* Filters Bar */}
        <div className="reports-filters-bar">
          <div className="filter-tabs">
            <button
              className={`filter-tab ${activeTab === "all" ? "active" : ""}`}
              onClick={() => setActiveTab("all")}
            >
              All Tickets
            </button>
            <button
              className={`filter-tab ${activeTab === "dispute" ? "active" : ""}`}
              onClick={() => setActiveTab("dispute")}
            >
              User Disputes
            </button>
            <button
              className={`filter-tab ${activeTab === "technical" ? "active" : ""}`}
              onClick={() => setActiveTab("technical")}
            >
              Technical Support
            </button>
          </div>

          <select
            className="status-filter"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All Status</option>
            <option value="submitted">Submitted</option>
            <option value="under-review">Under Review</option>
            <option value="in-progress">In Progress</option>
            <option value="resolved">Resolved</option>
            <option value="closed">Closed</option>
          </select>
        </div>

        {/* Tickets Table */}
        <div className="reports-table-wrapper">
          <table className="reports-table">
            <thead>
              <tr>
                <th>Ticket ID</th>
                <th>Issue Type</th>
                <th>Title</th>
                <th>Created By</th>
                <th>Against</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredReports.map((report) => {
                const typeConf = getTypeConfig(report.type);
                const statusConf = getStatusConfig(report.status);
                const isOpen =
                  report.status !== "resolved" && report.status !== "closed";
                return (
                  <tr
                    key={report.id}
                    onClick={() => setSelectedReport(report)}
                    className="rpt-table-row"
                  >
                    <td className="report-id">{report.id}</td>
                    <td>
                      <span className={`type-badge ${typeConf.cls}`}>
                        {typeConf.label}
                      </span>
                    </td>
                    <td className="report-title">{report.title}</td>
                    <td>
                      <div className="user-info">
                        <span className="user-name">{report.createdBy}</span>
                        <span className="user-role">
                          {report.createdByRole}
                        </span>
                      </div>
                    </td>
                    <td>
                      {report.against ? (
                        <div className="user-info">
                          <span className="user-name">{report.against}</span>
                          <span className="user-role">
                            {report.againstRole}
                          </span>
                        </div>
                      ) : (
                        <span className="rpt-na">—</span>
                      )}
                    </td>
                    <td>
                      <div className="priority-indicator">
                        <span
                          className="priority-dot"
                          style={{
                            backgroundColor: getPriorityColor(report.priority),
                          }}
                        ></span>
                        <span className="priority-text">{report.priority}</span>
                      </div>
                    </td>
                    <td>
                      <span className={`status-badge ${statusConf.cls}`}>
                        {statusConf.label}
                      </span>
                    </td>
                    <td className="report-date">{report.date}</td>
                    <td onClick={(e) => e.stopPropagation()}>
                      <div className="rpt-action-group">
                        {/* View */}
                        <button
                          className="rpt-action-btn rpt-btn-view"
                          title="View Details"
                          onClick={() => setSelectedReport(report)}
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        </button>

                        {/* Mark Resolved */}
                        {isOpen && (
                          <button
                            className="rpt-action-btn rpt-btn-resolve"
                            title="Mark Resolved"
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </button>
                        )}

                        {/* Escalate — high priority open tickets only */}
                        {isOpen && report.priority === "high" && (
                          <button
                            className="rpt-action-btn rpt-btn-escalate"
                            title="Escalate"
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <polyline points="17 11 12 6 7 11"></polyline>
                              <polyline points="17 18 12 13 7 18"></polyline>
                            </svg>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}

              {filteredReports.length === 0 && (
                <tr>
                  <td colSpan={9} className="rpt-empty-state">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                    </svg>
                    <p>No tickets found</p>
                    <span>Try adjusting your filters</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Ticket Detail Modal */}
        {selectedReport && (
          <div
            className="modal-overlay"
            onClick={() => setSelectedReport(null)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <div>
                  <h3>{selectedReport.title}</h3>
                  <span className="modal-report-id">{selectedReport.id}</span>
                </div>
                <button
                  className="close-btn"
                  onClick={() => setSelectedReport(null)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              <div className="modal-body">
                <div className="report-meta">
                  <div className="meta-item">
                    <span className="meta-label">Issue Type</span>
                    <span
                      className={`type-badge ${getTypeConfig(selectedReport.type).cls}`}
                    >
                      {getTypeConfig(selectedReport.type).label}
                    </span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">Priority</span>
                    <div className="priority-indicator">
                      <span
                        className="priority-dot"
                        style={{
                          backgroundColor: getPriorityColor(
                            selectedReport.priority,
                          ),
                        }}
                      ></span>
                      <span style={{ textTransform: "capitalize" }}>
                        {selectedReport.priority}
                      </span>
                    </div>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">Status</span>
                    <span
                      className={`status-badge ${getStatusConfig(selectedReport.status).cls}`}
                    >
                      {getStatusConfig(selectedReport.status).label}
                    </span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">Date</span>
                    <span
                      style={{
                        fontSize: "0.95rem",
                        color: "#2c2c2c",
                        fontWeight: 500,
                      }}
                    >
                      {selectedReport.date}
                    </span>
                  </div>
                </div>

                <div className="report-parties">
                  <div className="party">
                    <h4>Created By</h4>
                    <div className="party-info">
                      <div className="party-avatar">
                        {selectedReport.createdBy.charAt(0)}
                      </div>
                      <div>
                        <p className="party-name">{selectedReport.createdBy}</p>
                        <p className="party-role">
                          {selectedReport.createdByRole}
                        </p>
                      </div>
                    </div>
                  </div>
                  {selectedReport.against && (
                    <div className="party">
                      <h4>Against</h4>
                      <div className="party-info">
                        <div className="party-avatar">
                          {selectedReport.against.charAt(0)}
                        </div>
                        <div>
                          <p className="party-name">{selectedReport.against}</p>
                          <p className="party-role">
                            {selectedReport.againstRole}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="report-section">
                  <h4>Description</h4>
                  <p>{selectedReport.description}</p>
                </div>

                {selectedReport.evidence.length > 0 && (
                  <div className="report-section">
                    <h4>Attachments</h4>
                    <div className="evidence-list">
                      {selectedReport.evidence.map((file, index) => (
                        <div key={index} className="evidence-item">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                            <polyline points="13 2 13 9 20 9"></polyline>
                          </svg>
                          <span>{file}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {selectedReport.resolution && (
                  <div className="report-section resolution">
                    <h4>Resolution</h4>
                    <p>{selectedReport.resolution}</p>
                  </div>
                )}

                <div className="report-section">
                  <h4>Timeline</h4>
                  <div className="report-timeline">
                    <div className="timeline-item">
                      <div className="timeline-dot"></div>
                      <div className="timeline-content">
                        <p className="timeline-title">Ticket Submitted</p>
                        <p className="timeline-date">
                          {selectedReport.date} at {selectedReport.time}
                        </p>
                      </div>
                    </div>
                    <div className="timeline-item">
                      <div className="timeline-dot"></div>
                      <div className="timeline-content">
                        <p className="timeline-title">
                          {selectedReport.updates} Updates Posted
                        </p>
                        <p className="timeline-date">
                          Last updated 2 hours ago
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="action-btn secondary"
                  onClick={() => setSelectedReport(null)}
                >
                  Close
                </button>
                <button className="action-btn secondary">Send Message</button>
                {selectedReport.status !== "resolved" &&
                  selectedReport.status !== "closed" && (
                    <>
                      <button className="action-btn warning">Escalate</button>
                      <button className="action-btn primary">
                        Mark Resolved
                      </button>
                    </>
                  )}
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Reports;
